<template>
    <p class="mt-0 md:mt-12">
    <UButton :to="to" variant="outline" trailing-icon="workbook:arrow-right" size="md"
        class="font-normal text-white ring-white min-h-11 px-6 z-10 translate-x-0">
        {{ label }}
    </UButton>
    </p>

</template>

<script lang="ts" setup>

const props = defineProps({
    to: {
        type: String,
        default: '/'
    }, 
    label: {
        type: String,
        default: 'Get Started'
    }
})

</script>